angular.module('bizmetryApp').controller('EditProfileDialogController', [
  '$scope',
  '$rootScope',
  '$mdDialog',
  '$mdToast',
  '$timeout',
  'UserProfileService',
  'dialogService',
  'currentUser',
  function (
    $scope,
    $rootScope,
    $mdDialog,
    $mdToast,
    $timeout,
    UserProfileService,
    dialogService,
    currentUser
  ) {

    // ── Init ──────────────────────────────────────────────────────────────────
    $scope.isLoading      = false;
    $scope.errorMessage   = '';
    $scope.successMessage = '';
    $scope.phoneValid     = null;
    $scope.twoFaValidated = false;

    // ── Password state — recibido via callback desde biz-password-input ─────────
    // El componente llama onPasswordChange(value, valid) en cada cambio interno.
    $scope.passwordValue = '';
    $scope.passwordValid = true;

    $scope.onPasswordChange = function (value, valid) {
      $scope.passwordValue = value;
      // Si el campo está vacío el usuario no quiere cambiar la contraseña:
      // siempre es válido independientemente de lo que reporte el componente.
      $scope.passwordValid = !value ? true : valid;
      $scope.checkForChanges();
    };

    var _validatedPhone = null;

    var original = {
      firstName:      currentUser.firstName     || '',
      lastName:       currentUser.lastName      || '',
      user2FANumber:  currentUser.user2FANumber || ''
    };

    $scope.formData = {
      firstName:    original.firstName,
      lastName:     original.lastName,
      user2FANumber: original.user2FANumber
    };

    // ── Watches ───────────────────────────────────────────────────────────────
    $scope.$watch('formData.user2FANumber', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        $scope.twoFaValidated = false;
        _validatedPhone = null;
        $scope.checkForChanges();
      }
    });

    $scope.$watch('phoneValid', function () { $scope.checkForChanges(); });

    // ── 2FA ───────────────────────────────────────────────────────────────────
    $scope.canValidate2FA = function () {
      return !!(
        $scope.formData.user2FANumber &&
        $scope.phoneValid === true &&
        !$scope.twoFaValidated
      );
    };

    $scope.phoneNumberChangedAfterValidation = function () {
      return $scope.twoFaValidated &&
        $scope.formData.user2FANumber !== _validatedPhone;
    };

    $scope.openTwoFaValidation = function () {
      $mdDialog.show({
        template: `
          <two-fa-validator
              email="{{ $ctrl.email }}"
              target-number="{{ $ctrl.targetNumber }}"
              on-success="$ctrl.onSuccess()"
              on-cancel="$ctrl.onCancel()">
          </two-fa-validator>
        `,
        controller: function ($mdDialog) {
          this.email = currentUser.email;
          this.targetNumber = $scope.formData.user2FANumber;
          this.onSuccess = function () { $mdDialog.hide({ success: true }); };
          this.onCancel  = function () { $mdDialog.cancel(); };
        },
        controllerAs: '$ctrl',
        clickOutsideToClose: false,
        escapeToClose: false,
        multiple: true
      })
        .then(function (result) {
          if (result && result.success) {
            $scope.twoFaValidated = true;
            _validatedPhone = $scope.formData.user2FANumber;
            $scope.checkForChanges();

            $mdToast.show(
              $mdToast.simple()
                .textContent('✅ Phone number verified successfully')
                .position('top right')
                .hideDelay(3000)
            );
          }
        })
        .catch(function () {});
    };

    // Number currently registered (the one Unlink removes), not the one being typed
    $scope.linked2FANumber = function () {
      return original.user2FANumber;
    };

    // Unlink: removes the registered number right away (no Save needed)
    $scope.unlinking = false;

    $scope.unlink2FA = function () {
      dialogService.showDecisionDialog(
        'Unlink 2FA Device',
        'Unlink the mobile number <strong>' + original.user2FANumber + '</strong> from your account? '
          + 'You will no longer receive 2FA codes or SMS alerts — agents and interceptors that alert you by '
          + 'SMS stop doing so — until a new number is validated.',
        { goBack: 'Cancel', proceed: 'Unlink' }
      ).then(function (decision) {
        if (decision !== 'proceed') return;
        $scope.unlinking = true;
        UserProfileService.patchUserProfile({ user2FANumber: '' })
          .then(function () {
            original.user2FANumber      = '';
            currentUser.user2FANumber   = null;
            currentUser.user2FAEnabled  = false;
            $scope.formData.user2FANumber = '';
            $scope.twoFaValidated = false;
            _validatedPhone = null;
            $scope.checkForChanges();

            try {
              var user = JSON.parse(sessionStorage.getItem('user') || '{}');
              user.user2FANumber  = null;
              user.user2FAEnabled = false;
              sessionStorage.setItem('user', JSON.stringify(user));
            } catch (e) {}

            $mdToast.show(
              $mdToast.simple()
                .textContent('✅ 2FA device unlinked')
                .position('top right')
                .hideDelay(3000)
            );
          })
          .catch(function (error) {
            var msg = (error.data && error.data.message) || 'Failed to unlink the 2FA device';
            $mdToast.show(
              $mdToast.simple()
                .textContent('❌ ' + msg)
                .position('top right')
                .hideDelay(4000)
            );
          })
          .finally(function () { $scope.unlinking = false; });
      });
    };

    // ── hasChanges ────────────────────────────────────────────────────────────
    $scope.hasChanges = false;

    $scope.checkForChanges = function () {
      var nameChanged  = ($scope.formData.firstName  || '') !== original.firstName ||
                         ($scope.formData.lastName   || '') !== original.lastName;

      var phoneChanged = ($scope.formData.user2FANumber || '') !== original.user2FANumber;
      var phoneOk      = phoneChanged && $scope.twoFaValidated;

      // Si el teléfono cambió pero no fue validado no puede contribuir al guardado,
      // pero otros cambios (nombre, password) sí deben habilitar el botón.
      var pwdOk = !!$scope.passwordValue && $scope.passwordValid === true;

      $scope.hasChanges = nameChanged || phoneOk || pwdOk;
    };

    // ── Save ──────────────────────────────────────────────────────────────────
    $scope.saveChanges = function () {
      if ($scope.editProfileForm && $scope.editProfileForm.$setSubmitted) {
        $scope.editProfileForm.$setSubmitted();
      }

      if (!$scope.hasChanges || $scope.isLoading) return;

      // Validación final de password (segunda línea de defensa)
      if ($scope.passwordValue && !$scope.passwordValid) {
        $scope.errorMessage = 'Password does not meet requirements or does not match';
        return;
      }

      $scope.errorMessage   = '';
      $scope.successMessage = '';
      $scope.isLoading      = true;

      var payload = {};

      if (($scope.formData.firstName  || '') !== original.firstName)
        payload.firstName = $scope.formData.firstName;

      if (($scope.formData.lastName   || '') !== original.lastName)
        payload.lastName = $scope.formData.lastName;

      if ($scope.twoFaValidated &&
          ($scope.formData.user2FANumber || '') !== original.user2FANumber)
        payload.user2FANumber = $scope.formData.user2FANumber;

      if ($scope.passwordValue && $scope.passwordValid)
        payload.password = $scope.passwordValue;

      UserProfileService.patchUserProfile(payload)
        .then(function () {
          var messages = [];
          if (payload.firstName || payload.lastName) messages.push('Name updated');
          if (payload.user2FANumber)                 messages.push('2FA number updated');
          if (payload.password)                      messages.push('Password changed');

          $scope.successMessage = messages.join(' · ') + ' successfully!';

          try {
            var user = JSON.parse(sessionStorage.getItem('user') || '{}');
            if (payload.firstName)     user.firstName     = payload.firstName;
            if (payload.lastName)      user.lastName      = payload.lastName;
            if (payload.user2FANumber) user.user2FANumber = payload.user2FANumber;
            sessionStorage.setItem('user', JSON.stringify(user));
          } catch (e) {}

          $rootScope.$broadcast('user:profileUpdated', {
            firstName:    $scope.formData.firstName,
            lastName:     $scope.formData.lastName,
            user2FANumber: $scope.formData.user2FANumber
          });

          $mdToast.show(
            $mdToast.simple()
              .textContent($scope.successMessage)
              .position('top right')
              .hideDelay(3000)
          );

          $timeout(function () {
            $mdDialog.hide({
              firstName:       $scope.formData.firstName,
              lastName:        $scope.formData.lastName,
              user2FANumber:   $scope.formData.user2FANumber,
              passwordChanged: !!payload.password
            });
          }, 500);
        })
        .catch(function (error) {
          $scope.isLoading = false;
          if      (error.status === 400)              $scope.errorMessage = (error.data && error.data.message) || 'Invalid data';
          else if (error.status === 404)              $scope.errorMessage = 'User not found';
          else if (error.status === 401 || error.status === 403) $scope.errorMessage = 'Unauthorized';
          else                                        $scope.errorMessage = 'Failed to save changes. Please try again.';

          $mdToast.show(
            $mdToast.simple()
              .textContent($scope.errorMessage)
              .position('top right')
              .hideDelay(4000)
          );
        });
    };

    $scope.cancel = function () { $mdDialog.cancel(); };
  }
]);